import QuotedPriceDetail from './QuotedPriceDetail'

export default QuotedPriceDetail
